

export const allergens: any[] = [
    {
        id: 1,
        name: "Gluten"
    },
    {
        id: 2,
        name: "Crustacés"
    },
    {
        id: 3,
        name: "Oeufs"
    },
    {
        id: 4,
        name: "Poissons"
    },
    {
        id: 5,
        name: "Arachides"
    },
    {
        id: 6,
        name: "Soja"
    },
    {
        id: 7,
        name: "Lait"
    },
    {
        id: 8,
        name: "Fruits à coques"
    },
    {
        id: 9,
        name: "Céleri"
    },
    {
        id: 10,
        name: "Moutarde"
    },
    {
        id: 11,
        name: "Graines de sésame"
    },
    {
        id: 12,
        name: "Anhydride sulfureux et sulfites"
    },
    {
        id: 13,
        name: "Lupin"
    },
    {
        id: 14,
        name: "Mollusques"
    },

]